import { render, staticRenderFns } from "./AffiliateDetails.vue?vue&type=template&id=f530a236&scoped=true&"
import script from "./AffiliateDetails.vue?vue&type=script&lang=js&"
export * from "./AffiliateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f530a236",
  null
  
)

export default component.exports